(function () {
	function isInstagramBrowser() {
		return /Instagram/i.test(navigator.userAgent || '');
	}

	function forceVideoAttrs(video) {
		if (!video) return;
		video.muted = true;
		video.defaultMuted = true;
		video.autoplay = true;
		video.loop = true;
		video.playsInline = true;
		video.controls = false;
		video.preload = 'auto';
		video.setAttribute('muted', '');
		video.setAttribute('autoplay', '');
		video.setAttribute('loop', '');
		video.setAttribute('playsinline', 'playsinline');
		video.setAttribute('webkit-playsinline', 'webkit-playsinline');
		video.setAttribute('preload', 'auto');
		video.removeAttribute('controls');
	}

	function tryPlay(video) {
		if (!video) return;
		forceVideoAttrs(video);
		const promise = video.play();
		if (promise && typeof promise.catch === 'function') {
			promise.catch(function () {});
		}
	}

	function initVideoFix(scope) {
		if (!scope) scope = document;
		scope.querySelectorAll('.slideshow-video').forEach(function (video) {
			if (!video.dataset.autoplayBound) {
				video.dataset.autoplayBound = 'true';
				video.addEventListener('loadedmetadata', function () { tryPlay(video); });
				video.addEventListener('loadeddata', function () { tryPlay(video); });
				video.addEventListener('canplay', function () { tryPlay(video); });
				video.addEventListener('suspend', function () { tryPlay(video); });
				video.addEventListener('pause', function () {
					// Re-play if paused by browser (low battery, background, etc.)
					if (!video.ended) {
						setTimeout(function () { tryPlay(video); }, 200);
					}
				});
			}

			tryPlay(video);
			requestAnimationFrame(function () { tryPlay(video); });
			setTimeout(function () { tryPlay(video); }, 150);
			setTimeout(function () { tryPlay(video); }, 500);
			setTimeout(function () { tryPlay(video); }, 1200);
			setTimeout(function () { tryPlay(video); }, 2500);
		});
	}

	function slideshowInstagram() {
		document.querySelectorAll(".slideshow").forEach((block) => {
			let box = block.closest("section");
			let id = box.getAttribute("id");
			block = $(block);

			const autoplay = block.data("autoplay");
			const stopAutoplay = block.data("stop-autoplay");
			const delay = block.data("delay") * 1000;
			const speed = block.data("speed") * 1000;
			const effect = block.data("effect");

			let swiperParams = { speed: speed, keyboard: true, loop: true };

			let autoplayParams = autoplay ? {
				autoplay: {
					delay: delay,
					disableOnInteraction: false,
					pauseOnMouseEnter: stopAutoplay,
				},
			} : {};

			let swiperTextSelector = `#${id} .slideshow__tabs-wrapper`;
			let swiperTextElement = document.querySelector(swiperTextSelector);

			const swiperText = new Swiper(swiperTextSelector, {
				...swiperParams,
				spaceBetween: 24,
				direction: "horizontal",
				slidesPerView: "auto",
				allowTouchMove: false,
				breakpoints: {
					990: { allowTouchMove: true },
					1600: { allowTouchMove: false, touchRatio: 0, keyboard: { enabled: false } },
				},
				on: {
					init: function () { swiperTextElement.classList.add('first_step'); },
					slideChange: function () { swiperTextElement.classList.remove('first_step'); }
				}
			});

			let swiperImgSelector = `#${id} .slideshow__contents-wrapper`;
			let swiperImgElement = document.querySelector(swiperImgSelector);

			const swiperImg = new Swiper(swiperImgSelector, {
				pagination: { el: `#${id} .swiper-pagination`, clickable: true },
				...swiperParams,
				...autoplayParams,
				effect: effect,
				thumbs: { swiper: swiperText },
				on: {
					init: function () {
						swiperImgElement.classList.add('first_step');
						box.style.setProperty('--bullet-duration', `${delay}ms`);
						initVideoFix(swiperImgElement);
					},
					slideChange: function () {
						box.style.setProperty('--bullet-duration', `${delay + speed}ms`);
						initVideoFix(swiperImgElement);
					},
					slideChangeTransitionEnd: function () {
						swiperImgElement.classList.remove('first_step');
					}
				}
			});

			if (autoplay && stopAutoplay) {
				swiperImgElement.addEventListener("mouseenter", function () { swiperTextElement.classList.add("stop_move"); });
				swiperImgElement.addEventListener("mouseleave", function () { swiperTextElement.classList.remove("stop_move"); });
			}

			if ($(block.find(".slideshow__content")).length === 1) {
				swiperImgElement.classList.add('no_slideshow');
				swiperTextElement.classList.add('no_slideshow');
				swiperImg.destroy(true, true);
				swiperText.destroy(true, true);
				initVideoFix(swiperImgElement);
			}
		});
	}

	function waitForGestureAndPlay() {
    function onGesture() {
        initVideoFix(document);
        document.removeEventListener('touchstart', onGesture);
        document.removeEventListener('pointerdown', onGesture);
        document.removeEventListener('scroll', onGesture);
    }
    document.addEventListener('touchstart', onGesture, { passive: true });
    document.addEventListener('pointerdown', onGesture, { passive: true });
    document.addEventListener('scroll', onGesture, { passive: true });
}

	function slideshowDefault() {
		document.querySelectorAll(".slideshow").forEach((block) => {
			let box = block.closest("section");
			let id = box.getAttribute("id");
			block = $(block);

			const autoplay = block.data("autoplay");
			const stopAutoplay = block.data("stop-autoplay");
			const delay = block.data("delay") * 1000;
			const speed = block.data("speed") * 1000;
			const effect = block.data("effect");

			let swiperParams = { speed: speed, keyboard: true, loop: true };

			let autoplayParams = autoplay ? {
				autoplay: {
					delay: delay,
					disableOnInteraction: false,
					pauseOnMouseEnter: stopAutoplay,
				},
			} : {};

			let swiperTextSelector = `#${id} .slideshow__tabs-wrapper`;
			let swiperTextElement = document.querySelector(swiperTextSelector);

			const swiperText = new Swiper(swiperTextSelector, {
				...swiperParams,
				spaceBetween: 24,
				direction: "horizontal",
				slidesPerView: "auto",
				allowTouchMove: false,
				breakpoints: {
					990: { allowTouchMove: true },
					1600: { allowTouchMove: false, touchRatio: 0, keyboard: { enabled: false } },
				},
				on: {
					init: function () { swiperTextElement.classList.add('first_step'); },
					slideChange: function () { swiperTextElement.classList.remove('first_step'); }
				}
			});

			let swiperImgSelector = `#${id} .slideshow__contents-wrapper`;
			let swiperImgElement = document.querySelector(swiperImgSelector);

			const swiperImg = new Swiper(swiperImgSelector, {
				pagination: { el: `#${id} .swiper-pagination`, clickable: true },
				...swiperParams,
				...autoplayParams,
				effect: effect,
				thumbs: { swiper: swiperText },
				on: {
					init: function () {
						swiperImgElement.classList.add('first_step');
						box.style.setProperty('--bullet-duration', `${delay}ms`);
						initVideoFix(swiperImgElement);
					},
					slideChange: function () {
						box.style.setProperty('--bullet-duration', `${delay + speed}ms`);
						initVideoFix(swiperImgElement);
					},
					slideChangeTransitionEnd: function () {
						swiperImgElement.classList.remove('first_step');
					}
				}
			});

			if (autoplay && stopAutoplay) {
				swiperImgElement.addEventListener("mouseenter", function () { swiperTextElement.classList.add("stop_move"); });
				swiperImgElement.addEventListener("mouseleave", function () { swiperTextElement.classList.remove("stop_move"); });
			}

			if ($(block.find(".slideshow__content")).length === 1) {
				swiperImgElement.classList.add('no_slideshow');
				swiperTextElement.classList.add('no_slideshow');
				swiperImg.destroy(true, true);
				swiperText.destroy(true, true);
				initVideoFix(swiperImgElement);
			}

			// Retry after Swiper finishes cloning slides
			setTimeout(function () { initVideoFix(swiperImgElement); }, 300);
			setTimeout(function () { initVideoFix(swiperImgElement); }, 800);
		});
	}

	document.addEventListener("DOMContentLoaded", function () {
		if (isInstagramBrowser()) {
			slideshowInstagram();
			initVideoFix(document);

			document.addEventListener("shopify:section:load", function (event) {
				slideshowInstagram();
				initVideoFix(event.target || document);
			});

			document.addEventListener("visibilitychange", function () {
				if (document.visibilityState === "visible") { initVideoFix(document); }
			});

			window.addEventListener("focus", function () { initVideoFix(document); });
			window.addEventListener("pageshow", function () { initVideoFix(document); });

		} else {
			slideshowDefault();
			initVideoFix(document);
			waitForGestureAndPlay()

			document.addEventListener("shopify:section:load", function () {
				slideshowDefault();
				initVideoFix(document);
			});

			document.addEventListener("visibilitychange", function () {
				if (document.visibilityState === "visible") { initVideoFix(document); }
			});

			window.addEventListener("focus", function () { initVideoFix(document); });
			window.addEventListener("pageshow", function () { initVideoFix(document); });
		}
	});
})();